define(["require", "exports", "tslib", "@material-ui/core/CircularProgress", "react"], function (require, exports, tslib_1, CircularProgress_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Loading = void 0;
    CircularProgress_1 = tslib_1.__importDefault(CircularProgress_1);
    React = tslib_1.__importStar(React);
    const styles = {
        container: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1
        }
    };
    const Loading = (props) => {
        const size = props.size || 40;
        const style = props.style
            ? Object.assign(Object.assign({}, styles.container), props.style)
            : Object.assign({}, styles.container);
        return React.createElement("div", { style: style },
            React.createElement(CircularProgress_1.default, { size: size }));
    };
    exports.Loading = Loading;
});
